const map = {
	"./school-logo-00.svg": 812,
	"./school-logo-01.svg": 525,
	"./school-logo-02.svg": 406,
	"./school-logo-03.svg": 159,
	"./school-logo-04.svg": 952,
	"./school-logo-05.svg": 753,
	"./school-logo-06.svg": 858,
	"./school-logo-07.svg": 851,
	"./school-logo-08.svg": 308,
	"./school-logo-09.svg": 29,
	"./school-logo-10.svg": 255,
	"./school-logo-11.svg": 854,
	"./school-logo-12.svg": 477,
	"./school-logo-13.svg": 932,
	"./school-logo-14.svg": 507,
	"./school-logo-15.svg": 546
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;